import { toLower, capitalize } from 'lodash';

export const formatRaceName = (name) => {
    if (toLower(name) === 'total') { return 'TOTAL'; }

    return capitalize(name)
        .replace('aw', 'AW').replace('Nhf', 'NHF');
};

const raceNameIndexes = {
    Hurdle: 1,
    Chase: 2,
    NHF: 3,
};

export const sortByRaceName = key => (a, b) => {
    const name1 = a[key];
    const name2 = b[key];
    if (name1 === name2) { return 0; }

    const index1 = raceNameIndexes[name1];
    const index2 = raceNameIndexes[name2];
    if (index1 && index2) { return index1 - index2; }

    return name1 > name2 ? 1 : -1;
};



// WEBPACK FOOTER //
// ./src/js/utils/name.js